'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdApps = function MdApps(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.6 33.4v-6.8h6.8v6.8h-6.8z m0-10v-6.8h6.8v6.8h-6.8z m-10-10v-6.8h6.8v6.8h-6.8z m10-6.8h6.8v6.8h-6.8v-6.8z m-10 16.8v-6.8h6.8v6.8h-6.8z m-10 0v-6.8h6.8v6.8h-6.8z m0 10v-6.8h6.8v6.8h-6.8z m10 0v-6.8h6.8v6.8h-6.8z m-10-20v-6.8h6.8v6.8h-6.8z' })
        )
    );
};

exports.default = MdApps;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/apps.js
// module id = 3060
// module chunks = 168707334958949